// openEHR LANG model — BMM package org.openehr.lang.bmm
// Generated by tasks/split_model_by_bmm_packages.ts from tasks/bmm_package_map.json.
// Package boundaries follow the BMM package structure; edit the class bodies here,
// but re-run the splitter rather than hand-moving declarations between packages.

import { BMM_SIMPLE_CLASS, BMM_SIMPLE_TYPE } from "../_shared.ts";
import * as openehr_base from "../../base/mod.ts";

/**
 * Definitions used by all BMM packages.
 */
export class BMM_DEFINITIONS extends openehr_base.BASIC_DEFINITIONS {
  /**
   * built-in class definition corresponding to the top \`Any' class.
   * @returns Result value
   */
  Any_class(): BMM_SIMPLE_CLASS {
    // Return a built-in Any class definition
    const anyClass = new BMM_SIMPLE_CLASS();
    anyClass.name = "Any";
    anyClass.is_primitive = true;
    return anyClass;
  }

  /**
   * Built-in type definition corresponding to the top \`Any' type.
   * @returns Result value
   */
  Any_type(): BMM_SIMPLE_TYPE {
    const t = new BMM_SIMPLE_TYPE();
    t.base_class = this.Any_class();
    return t;
  }

  /**
   * Create schema id, formed from:
   *
   * \`a_model_publisher '-' a_schema_name '-' a_model_release\`
   *
   * e.g. \`openehr_rm_1.0.3\`, \`openehr_test_1.0.1\`, \`iso_13606_1_2008_2.1.2\`.
   * @param a_model_publisher - Parameter
   * @param a_schema_name - Parameter
   * @param a_model_release - Parameter
   * @returns Result value
   */
  create_schema_id(
    a_model_publisher: openehr_base.Any,
    a_schema_name: openehr_base.Any,
    a_model_release: openehr_base.String,
  ): openehr_base.String {
    // Format: publisher_schema_release (e.g., "openehr_rm_1.0.3")
    const publisher = String(a_model_publisher).toLowerCase();
    const schema = String(a_schema_name).toLowerCase();
    const release = a_model_release?.value || String(a_model_release);
    return openehr_base.String.from(`${publisher}_${schema}_${release}`);
  }
}
